var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":function($event){return _vm.openModal()}}},[_c('div',{staticClass:"cursor-pointer"},[_c('vk-icon',{attrs:{"icon":"move"}}),_c('span')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }